import React from 'react';

class Accessibility extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleMarginContainer = () => {
    if (this.props.location.pathname == '/accessibility') {
      return true;
    }
    return false;
  };

  render() {
    return (
      <div
        className={
          this.handleMarginContainer()
            ? 'accessibility-container--standalone'
            : 'accessibility-container'
        }
      >
        <h2>Promotion Wingman Accessibility Commitment </h2>
        <p>
          Kaplan North America, LLC affirms its commitment to making web-based,
          electronic content accessible to all learners who use the site in
          accordance with the Americans with Disabilities Act of 1990, as
          amended and other related local, state, and federal laws. Kaplan does
          not discriminate on the basis of disability in providing any of its
          services.
        </p>
        <p>
          If you have a disability and the format of any material on our web
          pages interferes with your ability to access the information, please
          contact
          <a href="mailto:accessibility@kaplan.com" className="mailto">
            accessibility@kaplan.com.
          </a>{' '}
          To enable us to respond in a manner most helpful to you, please
          indicate the nature of the accessibility problem, the web address of
          the requested material, and your contact information.
        </p>
      </div>
    );
  }
}

export default Accessibility;
